import React from "react";
import PropTypes from "prop-types";

const TextInput2 = ({
  type,
  icon,
  name,
  value,
  onChange,
  disabled,
  readonly,
  placeholder
}) => {
  return (
    <div className="app-search p-0 mb-1">
      <div className="input-group">
        <input
          data-tip
          type={type}
          name={name}
          value={value}
          htmlFor={name}
          data-for={name}
          onChange={onChange}
          disabled={disabled}
          readOnly={readonly}
          className="form-control form-control-sm"
          placeholder={placeholder}
          style={{ backgroundColor: "#d9e6f2" }}
        />
        <span className={icon}></span>
      </div>
    </div>
  );
};

TextInput2.propTypes = {
  readonly: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired
};

export default TextInput2;
